// @flow
export { default } from './LetterPlaceholder';



// WEBPACK FOOTER //
// ./src/components/letter/LetterPlaceholder/index.js